import { map } from 'lodash';
import { TypeObjectMap } from '../../../../../../components/Map/providers/enums';

export const LoadLayersOnTheMap = (layersKmz = [], mapRef) => {
    if (layersKmz?.length === 0 || !mapRef) return

    mapRef?.current?.removeMapObjects(TypeObjectMap.LayerKmz);

    layersKmz?.map(item => {
        if(!item?.presignedUrl) return
        const layer = new google.maps.KmlLayer({
            url: item.presignedUrl,
            enable: true,
            preserveViewport: true,
            map: mapRef.current?.mapItem,
        });

        mapRef && mapRef.current?.addMapObject({
            id: `kmzLayer_${item?.id}`,
            instance: layer,
            type: TypeObjectMap.LayerKmz,
            layerName: 'LayerKmz',
        })

    })
}

export const searchLayerOnTheMap = (item, mapRef) => {

    if (!item || !mapRef) return

    //remove the previus layer
    mapRef.current.removeMapObject(`kmzLayer_${item.id}`, TypeObjectMap.LayerKmz);

    //adding the new layer
    const layer = new google.maps.KmlLayer({
        url: item?.presignedUrl,
        enable: true,
        preserveViewport: false,
        map: mapRef.current?.mapItem,
    });

    mapRef && mapRef.current?.addMapObject({
        id: `kmzLayer_${item?.id}`,
        instance: layer,
        type: TypeObjectMap.LayerKmz,
        layerName: 'LayerKmz',
    })
}